import { Image, Platform, ScrollView, View, Text, StyleSheet } from 'react-native'
import { router } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Logo } from '../assets/icons/Logo'
import { Button } from '@/src/common/components/Button'
import { OnboardingWrapper } from '@/src/common/wrappers/OnboardingWrapper'
import { AuthenticationE2E } from '../experiences/authentication/e2e'
import { fontFamilies, typography, mesaColorNames } from '@/src/common/theme'

export default function GetStartedScreen() {
  return (
    <OnboardingWrapper paddingHorizontal={10}>
      <ScrollView contentContainerStyle={{ paddingBottom: 32 }}>
        <View style={styles.mainContainer}>
          <View>
            <View style={styles.logosContainer}>
              <View style={{ ...styles.logoContainer, marginTop: 10 }}>
                <Logo />
              </View>
              <View style={styles.logoContainer}>
                <Image
                  source={require('@/src/assets/images/house.png')}
                  resizeMode="contain"
                  style={styles.houseContainer}
                />
              </View>
            </View>
            <View>
              <Text style={[typography.XXL, styles.title]}>
                Get Rewarded for{'\n'}Being a Homeowner
              </Text>
              <Text style={styles.subtitle}>
                Earn rewards on your mortgage payments, refinances, home improvements, and everyday
                purchases.
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
      <View style={{ marginBottom: 10 }}>
        <Button
          segmentAction="User Got Started"
          title="Get started"
          testID={AuthenticationE2E.Ids.Press.GetStarted}
          onPress={() => router.push(Routes.Onboarding.route)}
        />
      </View>
    </OnboardingWrapper>
  )
}

const styles = StyleSheet.create({
  mainContainer: {
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  houseContainer: {
    width: 297,
    height: 297,
  },
  logosContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 30,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 2,
  },
  title: {
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: fontFamilies['PlusJakartaSans-Regular'],
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
    color: mesaColorNames['Greyscale/600 #505D64'],
    marginTop: 28,
    marginBottom: Platform.OS === 'web' ? 28 : 0,
  },
})
